import { render, staticRenderFns } from "./uploadItem.vue?vue&type=template&id=1bd49e50&scoped=true&"
import script from "./uploadItem.vue?vue&type=script&lang=js&"
export * from "./uploadItem.vue?vue&type=script&lang=js&"
import style0 from "./uploadItem.vue?vue&type=style&index=0&id=1bd49e50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd49e50",
  null
  
)

export default component.exports